import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const ANGULAR_LOGIN = 'https://accounts.honeysucklepub.com/auth/login';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const doScroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    };
    if (location.pathname === '/') {
      doScroll();
    } else {
      navigate('/');
      setTimeout(doScroll, 100);
    }
  };

  const navLinkStyle: React.CSSProperties = {
    fontSize: '13px',
    color: 'var(--gray-400)',
    transition: 'color 0.15s',
    textDecoration: 'none',
    cursor: 'pointer',
  };

  return (
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      padding: '0 40px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: scrolled ? 'rgba(0,0,0,0.85)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : '1px solid transparent',
      transition: 'all 0.3s ease',
    }}>
      {/* Logo */}
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{
          width: '28px',
          height: '28px',
          background: '#fff',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <span style={{ color: '#000', fontSize: '14px', fontWeight: '800', letterSpacing: '-0.05em' }}>H</span>
        </div>
        <span style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '-0.02em' }}>Honeysuckle</span>
      </Link>

      {/* Desktop Nav */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }} className="desktop-nav">
        <a
          href="#rewards"
          style={navLinkStyle}
          onClick={scrollToSection('rewards')}
          onMouseEnter={e => (e.target as HTMLElement).style.color = '#fff'}
          onMouseLeave={e => (e.target as HTMLElement).style.color = 'var(--gray-400)'}
        >Rewards</a>
        <a
          href="#plus"
          style={navLinkStyle}
          onClick={scrollToSection('plus')}
          onMouseEnter={e => (e.target as HTMLElement).style.color = '#fff'}
          onMouseLeave={e => (e.target as HTMLElement).style.color = 'var(--gray-400)'}
        >Honeysuckle+</a>
        <a
          href="#branches"
          style={navLinkStyle}
          onClick={scrollToSection('branches')}
          onMouseEnter={e => (e.target as HTMLElement).style.color = '#fff'}
          onMouseLeave={e => (e.target as HTMLElement).style.color = 'var(--gray-400)'}
        >Branches</a>
      </div>

      {/* CTA */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <a
          href={ANGULAR_LOGIN}
          style={{
            fontSize: '13px',
            color: 'var(--gray-400)',
            transition: 'color 0.15s',
            fontWeight: '500',
            textDecoration: 'none',
          }}
          onMouseEnter={e => (e.target as HTMLElement).style.color = '#fff'}
          onMouseLeave={e => (e.target as HTMLElement).style.color = 'var(--gray-400)'}
        >Log in</a>
        <Link to="/register" className="btn-primary" style={{ padding: '8px 16px', fontSize: '13px', borderRadius: '6px' }}>
          Join Free
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;